<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-select
                            v-model="roomPaths"
                            multiple
                            placeholder="请选择房间类型">
                        <el-option
                                v-for="item in roomPathsArr"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-input
                            class="common-el-input-small"
                            placeholder="输入联盟ID查询"
                            v-model="searchVal">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="searchTribeUserStats()">搜索</el-button>
                    <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>
        <div>
            <strong class="common-text-item" v-text="`总保险池：${tribeUserStats.totalInsurance/100}`"></strong>
            <strong class="common-text-item" v-text="`总手数：${tribeUserStats.totalHands}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="tribeUserStats.beanList"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="玩家昵称" width="150" align="center" prop="nickname"/>
                <el-table-column label="玩家ID" width="120" align="center" prop="randomNum"/>
                <el-table-column label="总积分" align="center" prop="totalIntegral">
                  <template slot-scope="scope">{{scope.row.totalIntegral|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总保险" align="center" prop="totalInsurance">
                  <template slot-scope="scope">{{scope.row.totalInsurance|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总手数" align="center" prop="totalHands"/>
                <el-table-column label="总房间数" align="center" prop="totalRoom"/>
                <el-table-column label="总带入次数" width="150" align="center" prop="totalBringTimes"/>
                <el-table-column label="总JP" align="center" prop="totalJackpot">
                  <template slot-scope="scope">{{scope.row.totalJackpot|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总JP利润" align="center" prop="totalJackpotProfit">
                  <template slot-scope="scope">{{scope.row.totalJackpotProfit|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总JP Real" width="120" align="center" prop="totalJackpotReal">
                  <template slot-scope="scope">{{scope.row.totalJackpotReal|numberChip}}</template>
                </el-table-column>
                <el-table-column label="所属俱乐部" width="180" align="center" prop="clubName"/>

                <el-table-column label="常用手机设备" width="350" align="center" prop="commonPhone"/>
                <el-table-column label="GPS" width="250" align="center" prop="gps"/>
                <el-table-column label="最近带入地点" width="250" align="center" prop="recentBringAddr"/>
                <el-table-column label="常用IP" width="150" align="center" prop="commonIp"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="tribeUserStats.total"
                :current-page="currentPage"
                @current-change="searchTribeUserStats({page:$event})"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                roomPathsArr: [{label: '普通局', value: 61}, {label: '奥马哈', value: 91}],
                roomPaths: [],
                date: null,
                searchVal: null,
                tribeUserStats: {// 联盟牌局信息
                    beanList: [],
                    total: 0,
                    totalInsurance: 0,// 总保险
                    totalHands: 0,// 总手数
                },
                currentPage: 1
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getTribeUserStats']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                if (!this.searchVal) {
                    this.$message.error('请输入联盟ID');
                    return false
                }
                if (!this.roomPaths.length) {
                    this.$message.error('请选择房间类型');
                    return false
                }
                return true
            },
            searchTribeUserStats(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    tribeRandomId: this.searchVal,
                    roomPaths: this.roomPaths,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page: 1,
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getTribeUserStats(params).then(res => {
                    this.tribeUserStats = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/gameDetail/tribe/user/stats/export',
                    info: [
                        {name: 'tribeRandomId', value: this.searchVal},
                        {name: 'roomPaths', value: this.roomPaths.join(',')},
                        {name: 'startTime', value: this.date[0]},
                        {name: 'endTime', value: this.date[1]}
                    ]

                })
            }
        }
    }
</script>